import kr from '../kr/kr';

export default class UploadedFilename extends kr.Component {
    init() {
        this.getNameOfFile();
    }
    getNameOfFile() {
        const fileInputElement = document.querySelector('.form__rev-file');
        const fileInputLabel = document.querySelector('.fake-file span');
        let filenameArray;
        fileInputElement.addEventListener('change', ()=> {
            filenameArray = fileInputElement.value.split('\\');
            if(filenameArray[filenameArray.length-1] !== '') {
                fileInputLabel.innerHTML = filenameArray[filenameArray.length-1];
            }
        })
    }
}

kr.registerComponent('.form__file', {
    component: UploadedFilename
});